// extracted by mini-css-extract-plugin
module.exports = {"mark":"bd_f0","mark_color_default":"bd_f1","mark_color_green":"bd_f2","mark_fill":"bd_f3","mark_color_red":"bd_f4","mark_color_blue":"bd_f5","mark_bold":"bd_f6"};